import React from 'react';
import AuthService from 'library/authService/auth-service';
import Permissions from './Provider';

/**
 * Authorization
 * @description Higher Order Component for Authorization
 * @version 1.0.1
 */
const Authorization = allowedRoles => (WrappedComponent, Fallback = null) => {
  /**
   * @description get the user permisions from authService
   * @fires AuthService#whoami
   * @return {array} user permissions
   */
  const getPermissions = () => {
    const user = AuthService.whoami();
    return user.currentTenancyPermissions || [];
  };

  /**
   * @description Has the user got the permissions
   * @return {bool} user permissions
   */
  const hasPermissions = () => {
    const permissions = getPermissions();
    return !!+allowedRoles.filter(auth => permissions.includes(auth)).length;
  };

  const HOC = (props) => {
    const ReplacementComponent = Fallback ? <Fallback {...props} /> : null;
    return (
      hasPermissions()
        ? <Permissions.Consumer>{({ permissions }) => (<WrappedComponent permissions={permissions} {...props} />)}</Permissions.Consumer> : ReplacementComponent
    );
  };

  /**
   * @description Has the user got the permissions, expose to Authorized function
   * @return {bool} user permissions
   */
  HOC.hasPermissions = () => hasPermissions();

  return HOC;
};

export default Authorization;
